import type { InvoiceState, InvoiceType } from '@mynt/backoffice-api-spec/invoice'
import type { Dayjs } from 'dayjs'

export type InvoiceTableFilters = {
  state: InvoiceState[]
  type: InvoiceType[]
  invoiceDate: { from?: Dayjs; to?: Dayjs }
  settleDate: { from?: Dayjs; to?: Dayjs }
  dueDate: { from?: Dayjs; to?: Dayjs }
  receiverName: string
  invoiceNo: string
  currency: string[]
  grossTotalMin?: number
  grossTotalMax?: number
}

export const DEFAULT_FILTERS: InvoiceTableFilters = {
  state: [],
  type: [],
  invoiceDate: { from: undefined, to: undefined },
  settleDate: { from: undefined, to: undefined },
  dueDate: { from: undefined, to: undefined },
  receiverName: '',
  invoiceNo: '',
  currency: [],
  grossTotalMin: undefined,
  grossTotalMax: undefined,
}
